import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
// 需要左方向动画的路由用this.$router.to('****')
Router.prototype.togo = function (path) {
  this.isleft = true
  this.isright = false
  this.push(path)
}
// 需要右方向动画的路由用this.$router.goRight('****')
Router.prototype.goRight = function (path) {
  this.isright = true
  this.isleft = false
  this.push(path)
}
// 需要返回按钮动画的路由用this.$router.goBack()，返回上一个路由
Router.prototype.goBack = function () {
  this.isright = true
  this.isleft = false
  this.go(-1)
}
// 点击浏览器返回按钮执行，此时不需要路由回退
Router.prototype.togoback = function () {
  this.isright = true
  this.isleft = false
}
// 点击浏览器前进按钮执行
Router.prototype.togoin = function () {
  this.isright = false
  this.isleft = true
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL === 'PRO' ? '/gisweb/' : '',
  routes: [
    {
      path: '/',
      name: 'index',
      component: (resolve) => require(['@/pages/index'], resolve),
      meta: {
        title: '景区智慧导览'
      }
    }, {
      path: '/gps',
      name: 'gps',
      component: (resolve) => require(['@/pages/gps'], resolve),
      meta: {
        title: '景区智慧导览'
      }
    }, {
      path: '/survey',
      name: 'survey',
      component: (resolve) => require(['@/pages/survey'], resolve),
      meta: {
        title: '景区概况'
      }
    }, {
      path: '/detail_gps',
      name: 'detail_gps',
      component: (resolve) => require(['@/pages/detail_gps'], resolve),
      meta: {
        title: '景点详情'
      }
    }, {
      path: '/detail_zb',
      name: 'detail_zb',
      component: (resolve) => require(['@/pages/detail_zb'], resolve)
    },
    {
      path: '/scan',
      name: 'scan',
      component: (resolve) => require(['@/pages/scan'], resolve),
      meta: {
        title: '扫码导览'
      }
    }, {
      path: '/detail_scan',
      name: 'detail_scan',
      component: (resolve) => require(['@/pages/detail_scan'], resolve),
      meta: {
        title: '景点详情'
      }
    }, {
      path: '/vr',
      name: 'vr',
      component: (resolve) => require(['@/pages/vr'], resolve),
      meta: {
        title: 'VR导览'
      }
    }, {
      path: '/detail_vr',
      name: 'detail_vr',
      component: (resolve) => require(['@/pages/detail_vr'], resolve),
      meta: {
        title: 'VR景点详情'
      }
    },
    {
      path: '/gpsdetail/navigation',
      name: 'navigation',
      component: (resolve) => require(['@/pages/gpsDetail/navigation.vue'], resolve),
      meta: {
        title: '高德地图'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js